import { render, staticRenderFns } from "./MeetingTextHolderCard.vue?vue&type=template&id=1ded96ca&scoped=true&"
import script from "./MeetingTextHolderCard.vue?vue&type=script&lang=js&"
export * from "./MeetingTextHolderCard.vue?vue&type=script&lang=js&"
import style0 from "./MeetingTextHolderCard.vue?vue&type=style&index=0&id=1ded96ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded96ca",
  null
  
)

export default component.exports